import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { storesApi } from "../../api";
import { IDetailServices } from "../types";


type IServices = {
    loading: boolean;
    error: string | null;
    detail: IDetailServices | null
}

const initialState: IServices = {
    loading: false,
    error: null,
    detail: null,
};



export const fetchByDetailservices = createAsyncThunk<IDetailServices, number, { rejectValue: string }>(
    'services/fetchByDetailservices',
    async (id, { rejectWithValue }) => {
        try {
            const res = await storesApi.getDetailServices(id)
            console.log(res);
            return res.data;
         } catch (error: any) {
            console.log(error);
            return rejectWithValue(error.response?.data || 'Ошибка сервера');
        }
    })




const servicesSlice = createSlice({
    name: 'services',
    initialState,
    reducers: {},
    extraReducers: ({ addCase }) => {
        addCase(fetchByDetailservices.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        addCase(fetchByDetailservices.fulfilled, (state, action) => {
            state.detail = action.payload;
            state.loading = false;
        });
        addCase(fetchByDetailservices.rejected, (state) => {
            state.loading = false;
            state.error = 'Ошибка сервера!';
        });
    },
})



export default servicesSlice.reducer





